import { buildSrDraftPatch, hasManualCatalogueRate, isAutomaticFabricRate, hasUnresolvedFabricPricing, buildCatalogueRatePatch } from "./fabricTextEditing";
import { resolveFabricCatalogueRrp, getSrPriceRuleLabel } from "./fabricCatalogue";

// Snapshot mode is selected by the existing quote lifecycle, not by pricing metadata.
export const hasUnresolvedLiveFabricPricing = (rows, usesSavedSnapshot = false) =>
  !usesSavedSnapshot && rows.some(hasUnresolvedFabricPricing);

// Resolve a design within its selected parent, never infer the parent from SR text.
export function buildSrPricingCommitPatch(row, value, { brand, library, workspaceDefaultFabricWidthIn = 54 } = {}) {
  const patch = buildSrDraftPatch(row, String(value ?? "").trim());
  if (hasManualCatalogueRate(row) || !isAutomaticFabricRate(row)) return patch;
  const catalogue = library?.catalogues?.find(entry => entry.active && entry.id === row.catalogueId);
  if (!brand || !catalogue) return patch;
  const resolution = resolveFabricCatalogueRrp({ brand, library, catalogueId: catalogue.id, srNumber: patch.srNumber,
    fabricText: patch.fabric, existingMrp: "", workspaceDefaultFabricWidthIn });
  const ratePatch = buildCatalogueRatePatch(row, resolution);
  const widthPatch = row.fabricWidthManuallyOverridden === true || row.fabricWidthSource === "manual_override"
    ? {} : { fabricWidthIn: resolution.fabricWidthIn, fabricWidthSource: resolution.fabricWidthSource,
      fabricWidthManuallyOverridden: false, srRuleFabricWidthIn: resolution.srRuleFabricWidthIn,
      catalogueDefaultFabricWidthIn: resolution.catalogueDefaultFabricWidthIn };
  return { ...patch, ...(ratePatch.cataloguePricingError ? {} : widthPatch), ...ratePatch,
    srPriceRuleId: resolution.rule?.id || "", srPriceRuleType: resolution.rule?.ruleType || "default",
    srPriceRuleLabel: resolution.rule ? getSrPriceRuleLabel(resolution.rule) : "" };
}
